import I18n from 'I18n';
import { fromMoment, now, toFormattedString, toMoment } from 'foundations-components/transitional/utils/SimpleDate';
import moment from 'moment';
import { diff, parseDate } from 'utility-belt/dateTime';
import { isNone } from 'utility-belt/typeguards';
export const toDate = m => !m ? null : m.clone().utc(false).hour(0).minute(0).second(0).millisecond(0);
export const getUTCDateAtMidnight = () => I18n.moment.utc().hour(0).minute(0).second(0).millisecond(0);
export function getNumDaysFromNow(date) {
  return I18n.moment.duration(toMoment(date).diff(now(), 'days')).as('days');
}
export const calculateDaysUntil = date => {
  const parsedDate = parseDate(date);
  if (!parsedDate) {
    return 0;
  }
  return diff(getUTCDateAtMidnight().valueOf(), parsedDate, 'days');
};
export const unixTimestampToDate = (unixTimestamp, format) => {
  return toFormattedString(fromMoment(I18n.moment.utc(parseInt(unixTimestamp, 10))), format || 'MMM DD, YYYY');
};
export const isFutureDate = date => {
  if (isNone(date)) {
    return false;
  }
  if (typeof date === 'string') {
    const parsedTS = parseDate(date);
    const parsedDate = parsedTS ? toDate(moment(parsedTS)) : null;
    return parsedDate ? parsedDate.diff(getUTCDateAtMidnight(), 'days') > 0 : false;
  }
  const parsedDate = toDate(toMoment(date));
  return parsedDate ? parsedDate.diff(getUTCDateAtMidnight(), 'days') > 0 : false;
};
export const isWithinMonths = (date, months) => {
  if (isNone(date)) {
    return false;
  }
  const parsedDate = parseDate(date);
  if (!parsedDate) {
    return false;
  }
  const monthsFromNow = I18n.moment.utc().add(months, 'months').valueOf();
  return parsedDate < monthsFromNow;
};
export const isBetweenMonthsAndYear = (date, months) => {
  if (isNone(date)) {
    return false;
  }
  const parsedDate = parseDate(date);
  if (!parsedDate) {
    return false;
  }
  const monthsFromNow = getUTCDateAtMidnight().add(months, 'months').valueOf();
  const oneYearFromNow = getUTCDateAtMidnight().add(1, 'year').valueOf();
  return parsedDate >= monthsFromNow && parsedDate < oneYearFromNow;
};
export const isMoreThanOneYear = date => {
  if (isNone(date)) {
    return false;
  }
  const parsedDate = parseDate(date);
  if (!parsedDate) {
    return false;
  }
  const oneYearFromNow = getUTCDateAtMidnight().add(1, 'year').valueOf();
  return parsedDate >= oneYearFromNow;
};
export const getTimeUntilBreakdown = date => {
  const parsedDate = parseDate(date);
  if (!parsedDate) {
    return {
      years: 0,
      months: 0,
      days: 0
    };
  }
  const years = diff(getUTCDateAtMidnight().valueOf(), parsedDate, 'years');
  const months = diff(getUTCDateAtMidnight().valueOf(), parsedDate, 'months') - years * 12;
  const days = diff(getUTCDateAtMidnight().valueOf(), parsedDate, 'days') - years * 365 - months * 30.44 - 1;
  return {
    years: Math.round(years),
    months: Math.round(months),
    days: Math.round(days)
  };
};